import { render, staticRenderFns } from "./MessageAsComment.vue?vue&type=template&id=6aea4322&scoped=true"
import script from "./MessageAsComment.vue?vue&type=script&lang=js"
export * from "./MessageAsComment.vue?vue&type=script&lang=js"
import style0 from "./MessageAsComment.vue?vue&type=style&index=0&id=6aea4322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aea4322",
  null
  
)

export default component.exports